module.exports = __webpack_public_path__ + "static/media/menu-dots-white.92325739.svg";